import { transparentize } from 'polished';
import styled from 'styled-components';
import { LAYOUT } from '@/constants/styles';
import { safePolished } from '@/utils/safePolished';

export const StyledLoyaltyStateContainer = styled.div`
  align-items: center;
  background: ${({ theme }) => theme.global.secondary_body_color};
  display: flex;
  height: 400px;
  justify-content: center;
  padding: ${LAYOUT.GUTTER}px;
  text-align: center;
  width: 100%;

  > div {
    width: 100%;
  }

  h2,
  h3 {
    font-size: 20px;
    margin: 0 0 ${LAYOUT.GUTTER}px;

    @media (max-width: 767px) {
      font-size: 16px;
      margin-bottom: ${LAYOUT.GUTTER / 2}px;
    }
  }

  h3 {
    font-family: ${({ theme }) => theme.primary_font.regular.font_family};
    font-weight: normal;
  }

  @media (max-width: 767px) {
    height: auto;
    margin-top: ${LAYOUT.LOYALTY_MENU_HEIGHT_MOBILE}px;
    padding: ${LAYOUT.GUTTER * 2}px ${LAYOUT.GUTTER}px;
  }
`;

export const StyledPointsHeader = styled.h1<{ currentPoints: number }>`
  font-size: ${(props) => (props.currentPoints > 0 ? 48 : 32)}px;
  font-family: ${({ theme }) => theme.primary_font.bold.font_family};
  margin: 0 0 ${LAYOUT.GUTTER}px;

  @media (max-width: 767px) {
    font-size: ${(props: { currentPoints: number }) => (props.currentPoints > 0 ? 38 : 28)}px;
    margin-bottom: ${LAYOUT.GUTTER / 2}px;
  }
`;

export const StyledProgressBarHorizontal = styled.div`
  display: flex;
  margin: 0 0 ${LAYOUT.GUTTER}px;
  justify-content: center;

  .wrapper {
    max-width: 500px;
    width: 100%;
  }

  .progress-bar {
    width: 100%;
    background: ${({ theme }) =>
      safePolished(transparentize)('.9', theme.global.primary_border_color)};
    border-radius: 12px;
    border: 1px solid ${({ theme }) => theme.global.primary_border_color};
    overflow: hidden;
  }

  .progress-bar-fill {
    display: block;
    height: 24px;
    transition: width 500ms ease-in-out;
    background: ${({ theme }) => theme.global.primary_active_color};
    border-radius: 12px;
  }

  @media (max-width: 767px) {
    margin: 0 0 ${LAYOUT.GUTTER}px;
  }
`;

export const StyledFlexContainer = styled.div`
  display: flex;
  justify-content: center;
  margin: ${LAYOUT.GUTTER}px;
`;
